var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fade-in-fwd my-project-modal" }, [
    _c("div", { staticClass: "container mt-5 ml-2" }, [
      _c("h6", { staticClass: "font-weight-bold" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$resourceString["account.Trays.Option.Edit"]) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "wf-modal-button-close btn button-full",
          attrs: { type: "button" },
          on: { click: _vm.closeModal }
        },
        [
          _c("span", {
            staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
            attrs: { "aria-label": "Close modal" }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "step fade-in-fwd mt-2 mr-3" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12 font-16" }, [
          _c("label", { attrs: { for: "" } }, [
            _vm._v(
              _vm._s(
                _vm.$resourceString[
                  "myProject.Project.AddItemModal.ProductStep1.ProjectGridSize.Label"
                ]
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-4" },
          [
            _c("my-project-radio-field", {
              attrs: {
                options:
                  _vm.productData.type == 3
                    ? _vm.getContentWizardData.documentRadioOptions
                    : _vm.getContentWizardData.radioOptions,
                name: "size"
              },
              model: {
                value: _vm.step2.size,
                callback: function($$v) {
                  _vm.$set(_vm.step2, "size", $$v)
                },
                expression: "step2.size"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group mt-2" },
        [
          _vm.productData.type == 8
            ? _c(
                "label",
                { staticClass: "gray-bold", attrs: { for: "description" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.productData.type == 4
                          ? _vm.$resourceString[
                              "contentWizard.AddDocument.Description.Label"
                            ]
                          : _vm.productData.type == 0
                          ? _vm.$resourceString[
                              "myProject.Project.AddItemModal.ProductStep1.ProjectDescription.Label"
                            ]
                          : _vm.productData.type == 9
                          ? _vm.$resourceString[
                              "contentWizard.VirtualTray.TrayDescription.Label"
                            ]
                          : _vm.productData.type == 10
                          ? _vm.$resourceString[
                              "contentWizard.GalleryImages.ImageDescription.Label"
                            ]
                          : _vm.$resourceString["common.label.description"]
                      ) +
                      "\n        "
                  ),
                  _c("span", { staticClass: "optional-field ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$resourceString[
                            "contentWizard.Label.Field.Optional"
                          ]
                        ) +
                        " "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("my-project-description-field", {
            attrs: {
              customClass: "form-control",
              maxlength: "400",
              fieldId: "description",
              placeholder:
                _vm.$resourceString[
                  "myProject.ProductItem.Description.Placeholder"
                ]
            },
            model: {
              value: _vm.step2.description,
              callback: function($$v) {
                _vm.$set(_vm.step2, "description", $$v)
              },
              expression: "step2.description"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer border-0 px-0 mt-5" }, [
        _c("div", { staticClass: "justify-content-between w-100  row" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-primary",
              on: { click: _vm.closeModal }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.updateProjectItem($event)
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.Project.EditPage.EditSizeAndDesc.Button"
                      ]
                    ) +
                    "\n          "
                )
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }